// Author Lin
// Date 2021-11-02 15:14:47

class MintalMesInventoryMaterialQuantity {
    constructor({
            id = null,
            materialId = '',
            materialName = '',
            warehouseId = '',
            warehouseName = '',
            orderCode = '',
            orderQuantity = '',
            grade = '',
            quantity = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.materialId = materialId;
        this.materialName = materialName;
        this.warehouseId = warehouseId;
        this.warehouseName = warehouseName;
        this.orderCode = orderCode;
        this.orderQuantity = orderQuantity;
        this.grade = grade;
        this.quantity = quantity;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesInventoryMaterialQuantity();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialId',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.materialId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'materialName',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.materialName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseId',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.warehouseId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.warehouseName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'orderCode',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.orderCode',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'orderQuantity',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.orderQuantity',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'grade',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.grade',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'quantity',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.quantity',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        materialIdFilter : '',
        materialNameFilter : '',
        warehouseIdFilter : '',
        warehouseNameFilter : '',
        orderCodeFilter : '',
        orderQuantityFilter : '',
        gradeFilter : '',
        quantityFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'materialNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.filter.materialName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstMaterial'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
                    }
            },
            {
            key: 'warehouseNameFilter',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.filter.warehouseName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstWarehouse'
                ,correspondingField: 'warehouseName'
                ,fieldsBindingByEntityModalSelected: '{"warehouseId":"id"}'
                    }
            },
            {
            key: 'orderCodeFilter',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.filter.orderCode',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'gradeFilter',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.filter.grade',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'materialName',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.materialName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstMaterial'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
                    }
            },
            {
            key: 'warehouseName',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.warehouseName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstWarehouse'
                ,correspondingField: 'warehouseName'
                ,fieldsBindingByEntityModalSelected: '{"warehouseId":"id"}'
                    }
            },
            {
            key: 'orderCode',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.orderCode',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'orderQuantity',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.orderQuantity',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'grade',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.grade',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'quantity',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.quantity',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.inventory.mintalMesInventoryMaterialQuantity.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesInventoryMaterialQuantity, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    